import { Check, Wifi } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Text, XStack, YStack } from 'tamagui';
import { tokens } from 'tamagui-config';

interface WiFiNetworkCardProps {
  name: string;
  isConnected?: boolean;
  onConnect?: () => void;
  onDisconnect?: () => void;
}

export const WiFiNetworkCard: React.FC<WiFiNetworkCardProps> = ({
  name,
  isConnected,
  onConnect,
  onDisconnect,
}) => {
  const { t } = useTranslation();

  return (
    <YStack
      width={300}
      padding="$5"
      gap="$5"
      alignItems="flex-start"
      justifyContent="space-between"
      borderWidth={2}
      borderColor="$transparentBorder"
      borderRadius={16}
      backgroundColor={isConnected ? '$transparentBorder' : 'transparent'}>
      <YStack gap="$3" alignItems="flex-start" width="100%">
        <XStack justifyContent="space-between" alignItems="center" width="100%">
          <Wifi color={tokens.color.hgPrimary} size={40} />
          {isConnected && <Check color={tokens.color.successGreen} size={40} />}
        </XStack>
        <Text fontSize="$8.5">{name}</Text>
      </YStack>
      <XStack backgroundColor="$transparent">
        {isConnected ? (
          <Button
            onPress={onDisconnect}
            padding={0}
            backgroundColor={'transparent'}
            hoverStyle={{
              backgroundColor: 'transparent',
              outlineWidth: 0,
              borderWidth: 0,
              opacity: 0.8,
            }}
            pressStyle={{ backgroundColor: 'transparent', outlineWidth: 0 }}
            focusStyle={{ outlineWidth: 0 }}
            fontSize="$8.5"
            fontWeight="700">
            {t('settings.wifi.disconnect')}
          </Button>
        ) : (
          <Button
            onPress={onConnect}
            padding={0}
            backgroundColor={'transparent'}
            hoverStyle={{
              backgroundColor: 'transparent',
              outlineWidth: 0,
              borderWidth: 0,
              opacity: 0.8,
            }}
            pressStyle={{ backgroundColor: 'transparent', outlineWidth: 0 }}
            focusStyle={{ outlineWidth: 0 }}
            fontSize="$8.5"
            fontWeight="700">
            {t('settings.wifi.connect')}
          </Button>
        )}
      </XStack>
    </YStack>
  );
};
